import DashboardLayout from '../components/Dashboard/Layout/DashboardLayout.vue'
// GeneralViews
import NotFound from '../components/GeneralViews/NotFoundPage.vue'

// Dashboard pages
const Logout = () => import(/* webpackChunkName: "widgets" */ 'src/components/Dashboard/Views/Pages/logout.vue')
const Login = () => import(/* webpackChunkName: "widgets" */ 'src/components/Dashboard/Views/Pages/Login.vue')
const Agenda = () => import(/* webpackChunkName: "widgets" */ 'src/components/Dashboard/Views/Calendar/Calendar.vue')
const ClientsList = () => import(/* webpackChunkName: "widgets" */ 'src/components/Dashboard/Views/Client/clientList.vue')
const ClientShow = () => import(/* webpackChunkName: "widgets" */ 'src/components/Dashboard/Views/Client/clientShow.vue')
const ClientCommandes = () => import(/* webpackChunkName: "widgets" */ 'src/components/Dashboard/Views/Client/clientCommandes.vue')
const ClientAutre = () => import(/* webpackChunkName: "widgets" */ 'src/components/Dashboard/Views/Client/clientAutre.vue')
const ClientCreate = () => import(/* webpackChunkName: "widgets" */ 'src/components/Dashboard/Views/Client/clientCreate.vue')
const CommandesList = () => import(/* webpackChunkName: "widgets" */ 'src/components/Dashboard/Views/Commande/commandesList.vue')
const CommandeShow = () => import(/* webpackChunkName: "widgets" */ 'src/components/Dashboard/Views/Commande/commandeShow.vue')
const RequeteList = () => import(/* webpackChunkName: "widgets" */ 'src/components/Dashboard/Views/Requete/requeteList.vue')
const RequeteCreate = () => import(/* webpackChunkName: "widgets" */ 'src/components/Dashboard/Views/Requete/requeteCreate.vue')
const RequeteShow = () => import(/* webpackChunkName: "widgets" */ 'src/components/Dashboard/Views/Requete/requeteShow.vue')
const AideVenteList = () => import(/* webpackChunkName: "widgets" */ 'src/components/Dashboard/Views/AideVente/AideVenteList.vue')


let loginPage = {
  path: '/login',
  name: 'Login',
  component: Login
}

let root = {
  path: '/',
  component: DashboardLayout,
  redirect: '/login',
  children: [
    {
      path: 'deconnexion',
      name: 'Déconnexion',
      component: Logout,
      meta: { requiresAuth: true,}
    },
    {
      path: 'agenda',
      name: 'Agenda',
      component: Agenda,
      meta: { requiresAuth: true,}
    },
    {
      path: 'clients',
      name: 'Clients',
      component: ClientsList,
      meta: { requiresAuth: true,}
    },
    {
      path: 'client/:cid',
      name: 'Client',
      component: ClientShow,
      meta: { requiresAuth: true,}
    },
    {
      path: 'clientCommandes/:cid',
      name: 'ClientCommandes',
      component: ClientCommandes,
      meta: { requiresAuth: true,}
    },
    {
      path: 'clientAutre/:cid',
      name: 'ClientAutre',
      component: ClientAutre,
      meta: { requiresAuth: true,}
    },
    {
      path: 'clientCreate/',
      name: 'ClientCreate',
      component: ClientCreate,
      meta: { requiresAuth: true,}
    },
    {
      path: 'commandes',
      name: 'commandesList',
      component: CommandesList,
      meta: { requiresAuth: true,}
    },
    {
      path: 'commande/:oid',
      name: 'Commande',
      component: CommandeShow,
      meta: { requiresAuth: true,}
    },
    {
      path: 'requetes',
      name: 'Requetes',
      component: RequeteList,
      meta: { requiresAuth: true,}
    },
    {
      path: 'requeteCreate/:cid',
      name: 'requeteCreate',
      component: RequeteCreate,
      meta: { requiresAuth: true,}
    },
    {
      path: 'requete/:id_requete/:cid',
      name: 'Requete',
      component: RequeteShow,
      meta: { requiresAuth: true,}
    },
    {
      path: 'aides-ventes',
      name: 'AideVente',
      component: AideVenteList,
      meta: { requiresAuth: true,}
    }
  ]
}

const routes = [
  loginPage,
  root,
  {path: '*', component: NotFound}
];

export default routes
